import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { searchReturnTo } from '../components/searchReturnTo';
import { useAuth } from '../context/AuthContext';
import { PropertyDetails } from '../modules/PropertyDetails';

export const Route = createFileRoute('/property-details/$propertyId')({
  component: RouteComponent,
  params: z.object({
    propertyId: z.coerce.number().positive(),
  }),
  validateSearch: z.object({
    tab: z.string().optional(),
    // Set when opened from a search on a phone; shows Back to that search.
    returnTo: searchReturnTo,
  }),
});

function RouteComponent() {
  const { propertyId } = Route.useParams();
  const { tab, returnTo } = Route.useSearch();
  const { user } = useAuth();

  if (user.preferAdminView) {
    return <Navigate to="/properties/$propertyId" params={{ propertyId }} replace />;
  }

  return (
    <PropertyDetails
      key={propertyId}
      propertyId={propertyId}
      initialTab={tab}
      returnTo={returnTo}
    />
  );
}
